module.exports = __webpack_public_path__ + "img/bnn-logo-small.c3ca1fa7.svg";